import { render, staticRenderFns } from "./AccueilMenuIcon.vue?vue&type=template&id=1fcad4f6"
import script from "./AccueilMenuIcon.vue?vue&type=script&lang=js"
export * from "./AccueilMenuIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports